<template>
    <div>
        <label
            class="d-flex text-uppercase font-weight-bold"
        >
            {{ group.attribute.name }}
        </label>
        <OptionBtnGroupInput
            :model-value="model"
            :option="group"
            tall-buttons
        ></OptionBtnGroupInput>
    </div>
</template>

<script lang="ts" setup>
    import type {
        ProductOptionGroup
    } from '~/types';
    import OptionBtnGroupInput from '~/components/controls/OptionBtnGroupInput/OptionBtnGroupInput.vue';

    const props = defineProps<{
        group: ProductOptionGroup;
    }>();

    const model = computed<string>(() => {
        const selected = props.group.groupValues.find(
            (opt) => opt.value.isSelected
        );

        return selected?.value.uid ?? '';
    });
</script>

<style lang="scss"></style>
